import { render, staticRenderFns } from "./Gate.vue?vue&type=template&id=fae3c846&scoped=true"
import script from "./Gate.vue?vue&type=script&lang=js"
export * from "./Gate.vue?vue&type=script&lang=js"
import style0 from "./Gate.vue?vue&type=style&index=0&id=fae3c846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae3c846",
  null
  
)

export default component.exports